
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_1cyj5_14",
  "tab-header-scroll-container": "awsui_tab-header-scroll-container_14rmt_1cyj5_23",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_1cyj5_29",
  "pagination-button": "awsui_pagination-button_14rmt_1cyj5_46",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_1cyj5_53",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_1cyj5_56",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_1cyj5_60",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_1cyj5_63",
  "actions-container": "awsui_actions-container_14rmt_1cyj5_68",
  "tabs-tab": "awsui_tabs-tab_14rmt_1cyj5_76",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_1cyj5_86",
  "tabs-tab-header-container": "awsui_tabs-tab-header-container_14rmt_1cyj5_97",
  "tabs-tab-dismiss": "awsui_tabs-tab-dismiss_14rmt_1cyj5_105",
  "tabs-tab-action": "awsui_tabs-tab-action_14rmt_1cyj5_105",
  "refresh": "awsui_refresh_14rmt_1cyj5_110",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_1cyj5_114",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_1cyj5_156",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_1cyj5_239",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_1cyj5_248",
  "tabs-tab-focusable": "awsui_tabs-tab-focusable_14rmt_1cyj5_252",
  "root": "awsui_root_14rmt_1cyj5_256",
  "tabs": "awsui_tabs_14rmt_1cyj5_14",
  "tabs-content": "awsui_tabs-content_14rmt_1cyj5_294",
  "fit-height": "awsui_fit-height_14rmt_1cyj5_298",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_1cyj5_304",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_1cyj5_318",
  "with-paddings": "awsui_with-paddings_14rmt_1cyj5_318",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_1cyj5_329",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_14rmt_1cyj5_340",
  "tabs-tab-focused": "awsui_tabs-tab-focused_14rmt_1cyj5_344"
};
  